import { useEffect, useState } from "react";
import Input from "../../../../../components/Inputs/Input";
import "./newDiscrepancyModal.scss";
import BasicDatePicker from "../../../../../components/Datepicker/Datepicker";
import { dropdownConfig } from "../../../../../services/dropdownsConfigService";
import { HTTP_RESPONSE_CODES } from "../../../../../globals/globals";
import Dropdowns from "../../../../../components/Dropdowns/Dropdowns";
import Skeleton from "react-loading-skeleton";
import { createDiscrepancy } from "../../../Services/ordersServices";
import { useSnackBar } from "../../../../../hooks/useSnackBar";
import {TextAreaComponent} from "../../../../../components/TextArea/TextAreaComponent"
export const NewDiscrepancyModal = ({
  qtyOrdered,
  UOMId,
  orderId,
  company_id,
  onClose,
  styles,
  isNewDiscrepancy = true,
  disabled = false
}) => {
  const [categorySelected, setCategorySelected] = useState("PN Does Not Exist");
  const [pnDrop, setPNDrop] = useState(null);
  const [discrepancies, setDiscrepancies] = useState(null);
  const [uomAbDrop, setUomAbDrop] = useState(null);
  const [form, setForm] = useState({
    discrepancy_type: null,
    discrepancy_id: null,
    non_existent_PN: null,
    wrong_pn: null,
    requested_qty: null,
    received_quantity: null,
    uom: null,
    shelfLife: null,
    description: "",
    order_id: null,
    company: null,
  });

  const { successMsg, warningMsg } = useSnackBar();
  
  // functions
  const getDropdownConfigPN = async () => {
    let id = 29;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setPNDrop(request.data.load);
    }
  };

  const getDropdownConfigDiscrepancies = async () => {
    let id = 141;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setDiscrepancies(request.data.load);
    }
  };

  const getDropdownConfigUOMAbbreviations = async () => {
    let id = 135;
    const request = await dropdownConfig(id);
    if (request.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
      setUomAbDrop(request.data.load);
    }
  };

  const getAllDropdowns = async () => {
    const results = await Promise.all([
      getDropdownConfigDiscrepancies(),
      getDropdownConfigPN(),
      getDropdownConfigUOMAbbreviations(),
    ]);

    return results;
  };

  const preloadFormData = (data) => {
    setForm((prev) => {
      return {
        ...prev,
        order_id: data.id,
        uom: data.uom,
        requested_qty: data.requested_qty,
        company: data.company,
      };
    });
  };

  const handleInputsChanges = (e) => {
    setForm((prev) => {
      return {
        ...prev,
        [e.target.name]: e.target.value,
      };
    });
  };

  const sendDiscrepancy = async () => {
    const {
      discrepancy_type,
      discrepancy_id,
      wrong_pn,
      non_existent_PN,
      requested_qty,
      received_quantity,
      uom,
      shelfLife,
      description,
      order_id,
      company,
    } = form;

    let body = {
      reason: description,
      vendorOrderDetailId: order_id,
      companyId: company,
      status: "Pending Review",
      // version : 0,
      discrepancyCategoryId: discrepancy_id,
    };

    switch (discrepancy_type) {
      case "Incorrect QTY":
        body.partNumber = null;
        body.partId = null;
        body.shelf_life = null;
        body.quantityReceived = received_quantity;
        body.uomId = uom;
        break;

      case "Expired Shelf Life":
        body.partNumber = null;
        body.partId = null;
        body.quantityReceived = null;
        body.uomId = null;
        body.shelf_life = shelfLife;
        break;

      case "Wrong PN":
        body.partNumber = null;
        body.quantityReceived = null;
        body.uomId = null;
        body.shelf_life = null;
        body.partId = wrong_pn;
        break;

      case "PN Does Not Exist":
        body.partId = null;
        body.quantityReceived = null;
        body.uomId = null;
        body.shelf_life = null;
        body.partNumber = non_existent_PN;
        break;

      case "Certification Issues":
      case "Damage":
      case "Expired ETs":
        break;

      default:
        console.warn("unknok Discrepancy:", discrepancy_type);
        break;
    }

    try {
      const request = await createDiscrepancy(body);
      if (request.data.responseCode == HTTP_RESPONSE_CODES.SUCCESS) {
        successMsg(
          "Discrepancy Sent",
          form.discrepancy_type + " Discrepancy Has Been Created Succesfully."
        );
        onClose();
      }
    } catch (error) {
      console.error("Error al enviar la discrepancia:", error);
    }
  };

  //effects
  useEffect(() => {
    const dataToPreload = {
      id: orderId,
      uom: UOMId,
      requested_qty: qtyOrdered,
      company: company_id,
    };
    preloadFormData(dataToPreload);

    getAllDropdowns();
  }, []);

  return (
    <section className="new-discrepancy-modal" style={{...styles}}>
      { isNewDiscrepancy ? <div>
        <h3>New Discrepancy</h3>{" "}
        <button className="new-discrepancy-modal-close-btn" onClick={onClose}>
          <i className="icon-cross"></i>
        </button>
      </div> : ""}
      <div>
        {discrepancies ? (
          <Dropdowns
          disabled={disabled}
            data={discrepancies}
            optionLabel={"name"}
            handleClear={() => {
              setForm((prev) => {
                return {
                  ...prev,
                  discrepancy_id: null,
                  discrepancy_type: null,
                };
              });
            }}
            onOptionSelect={(e) => {
              setForm((prev) => {
                return {
                  ...prev,
                  discrepancy_id: e.id,
                  discrepancy_type: e.type,
                };
              });
            }}
          ></Dropdowns>
        ) : (
          <Skeleton count={1} height={"2rem"}></Skeleton>
        )}
      </div>
      {form.discrepancy_type == "Incorrect QTY" ? (
        <div className="new-discrepancy-incorrect-qty-cont-fields">
          <p>Requested QTY</p>
          <Input
            style={{
              width: "15%",
            }}
            disabled={true}
            value={form.requested_qty}
            isNumeric={true}
            name={"requested_qty"}
          />
          <p>Received QTY</p>
          <Input
            style={{
              width: "15%",
            }}
            isNumeric={true}
            value={form.received_quantity}
            onChange={handleInputsChanges}
            name={"received_quantity"}
            disabled={disabled}
          ></Input>
          <p>UOM</p>
          <div
            style={{
              width: "18%",
            }}
          >
            <Dropdowns
            disabled={disabled}
              hideLabel={true}
              data={uomAbDrop}
              preSelectValue={form.uom}
              handleClear={() => {
                setForm((prev) => {
                  return {
                    ...prev,
                    uom: null,
                  };
                });
              }}
              onOptionSelect={(e) => {
                setForm((prev) => {
                  return {
                    ...prev,
                    uom: e.id,
                  };
                });
              }}
            ></Dropdowns>
          </div>
        </div>
      ) : form.discrepancy_type == "PN Does Not Exist" ? (
        <Input
        disabled={disabled}
          label={"Part Number (PN)"}
          value={form.non_existent_PN}
          name={"non_existent_PN"}
          onChange={handleInputsChanges}
        ></Input>
      ) : form.discrepancy_type == "Expired Shelf Life" ? (
        <BasicDatePicker
        disabled={disabled}
          label={"Shelf Life"}
          name={"shelfLife"}
          value={form.shelfLife}
          onChange={(e) => {
            setForm((prev) => {
              return {
                ...prev,
                shelfLife: e.$d,
              };
            });
          }}
        ></BasicDatePicker>
      ) : form.discrepancy_type == "Wrong PN" ? (
        <Dropdowns
        disabled={disabled}
          data={pnDrop}
          handleClear={() => {
            setForm((prev) => {
              return {
                ...prev,
                wrong_pn: null,
              };
            });
          }}
          onOptionSelect={(e) => {
            setForm((prev) => {
              return {
                ...prev,
                wrong_pn: e.id,
              };
            });
          }}
        ></Dropdowns>
      ) : null}
      <div
        style={{
          position: "relative",
          height:
            form.discrepancy_type == "Certification Issues" ||
            form.discrepancy_type == "Damage" ||
            form.discrepancy_type == "Expired ETs" ||
            form.discrepancy_type == "Other"
              ? "60%"
              : "40%",
        }}
      >
       
       <TextAreaComponent disabled={disabled} label={"Description"} onChange={handleInputsChanges} name={"description"} value={form.description} />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <button className="new-discrepancy-send-btn" onClick={sendDiscrepancy}>
          Send
        </button>
      </div>
    </section>
  );
};
